export const AnastasiaEvents = {
  meetingParentsGoodAnswers: false,
  disappearExplained: false
};

AnastasiaEvents.hasActiveEvent = () => {
  return AnastasiaEvents.firstTalk() ||
      AnastasiaEvents.canAnastasiaSecondTalk() ||
      AnastasiaEvents.isBeachFirstRequest() ||
      AnastasiaEvents.isFirstRestaurantDate() ||
      AnastasiaEvents.isFirstKissDate() ||
      AnastasiaEvents.isFirstSexEvent() ||
      AnastasiaEvents.isMettingVicky() ||
      AnastasiaEvents.meetingWithParents()
    ;
}

AnastasiaEvents.displayHint = () => {
  return AnastasiaEvents.canAnastasiaSecondTalk() ||
  AnastasiaEvents.isBeachFirstRequest() ||
  AnastasiaEvents.isFirstRestaurantDate() ||
  AnastasiaEvents.isFirstKissDate() ||
  AnastasiaEvents.isFirstSexEvent() ||
  AnastasiaEvents.isMettingVicky() ||
  AnastasiaEvents.meetingWithParents()
  ;
}

AnastasiaEvents.hasActiveQuest = () => {
  return false
}

AnastasiaEvents.genericTalk = () => {
  if(Yosemite.EventStateManager.anastasiaDailyEventChecked) return true;
  if(!Yosemite.EventStateManager.anastasiaFirstTalk) return false;
  return !AnastasiaEvents.hasActiveEvent() && !AnastasiaEvents.hasActiveQuest();
}

/*
- kup kawę
- komplement
 */
AnastasiaEvents.genericTalk_1 = () => {
  return !Yosemite.EventStateManager.anastasiaBeachFirstRequest
}

/*
- kup kawę
- komplement
- odmowa pójścia na plażę
 */
AnastasiaEvents.genericTalk_2 = () => {
  // Czy odbył się event z restauracją
  if(Yosemite.EventStateManager.anastasiaFirstRestaurantDate) {
    return false;
  }

  return Yosemite.EventStateManager.anastasiaBeachFirstRequest &&
    YsServices.questService.status(YsServices.questService.questEnum.RubinaGymTip) !== YsServices.questService.statusEnum.Completed;
}

/*
- kup kawę
- komplement
- pójście na plażę
 */
AnastasiaEvents.genericTalk_3 = () => {
  // Czy odbył się event z restauracją
  if(Yosemite.EventStateManager.anastasiaFirstRestaurantDate) {
    return false;
  }

  return Yosemite.EventStateManager.anastasiaBeachFirstRequest &&
    YsServices.questService.status(YsServices.questService.questEnum.RubinaGymTip) === YsServices.questService.statusEnum.Completed;
}

/*
- kup kawę
- komplement
- pójście na plażę
- pójście do restauracji
 */
AnastasiaEvents.genericTalk_4 = () => {
  return Yosemite.EventStateManager.anastasiaFirstRestaurantDate && !Yosemite.EventStateManager.anastasiaFirstSexEvent;
}

/*
- kup kawę
- komplement
- pójście na plażę
- pójście do restauracji
- sex
 */
AnastasiaEvents.genericTalk_5 = () => {
  return Yosemite.EventStateManager.anastasiaFirstSexEvent;
}

AnastasiaEvents.isWaifu = () => {
  return Yosemite.EventStateManager.anastasiaFirstSexEvent
}

AnastasiaEvents.firstTalk = () => {
  // czy dziś odbył się już jakikolwiek event
  if(Yosemite.EventStateManager.anastasiaDailyEventChecked) {
    return false;
  }

  return !Yosemite.EventStateManager.anastasiaFirstTalk;
}

AnastasiaEvents.canAnastasiaSecondTalk = () => {
  return Yosemite.EventStateManager.anastasiaFirstTalk &&
    !Yosemite.EventStateManager.state.coffeeShop.anastasia.secondTalk &&
    !Yosemite.EventStateManager.anastasiaDailyEventChecked;
}

AnastasiaEvents.isBeachFirstRequest = () => {
  // czy już taki event się odbył
  if(Yosemite.EventStateManager.anastasiaBeachFirstRequest) {
    return false;
  }

  // czy była już druga rozmowa
  if(!Yosemite.EventStateManager.anastasiaSecondTalk) {
    return false;
  }

  // czy dziś odbył się już jakikolwiek event
  if(Yosemite.EventStateManager.anastasiaDailyEventChecked) {
    return false;
  }

  // na koniec sprawdzamy statystyki
  return Yosemite.McManager.getFitness() >= 2;
}

AnastasiaEvents.isFirstRestaurantDate = () => {
  // czy już taki event się odbył
  if(Yosemite.EventStateManager.anastasiaFirstRestaurantDate) {
    return false;
  }

  // czy był już event plaża
  if (!Yosemite.EventStateManager.anastasiaBeachFirstRequest) {
    return false;
  }

  // czy dziś odbył się już jakikolwiek event
  if(Yosemite.EventStateManager.anastasiaDailyEventChecked) {
    return false;
  }

  // na koniec sprawdzamy statystyki
  return Yosemite.McManager.getFitness() >= 7;
}

AnastasiaEvents.isFirstKissDate = () => {
  // czy już taki event się odbył
  if(Yosemite.EventStateManager.anastasiaFirstKissDate) {
    return false;
  }

  // czy był już event restauracja
  if (!Yosemite.EventStateManager.anastasiaFirstRestaurantDate) {
    return false;
  }

  // czy zadanie z paczką do schroniska jest zrealizowane
  if(YsServices.questService.status(YsServices.questService.questEnum.AnimalShelter) !== 1) {
    return false;
  }

  // czy dziś odbył się już jakikolwiek event
  if(Yosemite.EventStateManager.anastasiaDailyEventChecked) {
    return false;
  }

  // na koniec sprawdzamy statystyki
  return Yosemite.McManager.getFitness() >= 7;
}

AnastasiaEvents.isFirstBirthday = () => {
  // czy już taki event się odbył
  if(Yosemite.EventStateManager.anastasiaFirstBirthday) {
    return false;
  }

  // czy był już event pierwszy pocałunek
  if(!Yosemite.EventStateManager.anastasiaFirstKissDate) {
    return false;
  }

  // czy zadanie z prezentem urodzinowym jest zrealizowane
  if(YsServices.questService.status(YsServices.questService.questEnum.BirthdayGift) !== 1) {
    return false;
  }

  // czy dziś odbył się już jakikolwiek event
  if(Yosemite.EventStateManager.anastasiaDailyEventChecked) {
    return false;
  }

  // na koniec sprawdzamy statystyki
  return Yosemite.McManager.getFitness() >= 7;
}

AnastasiaEvents.isFirstSexEvent = () => {
  // czy już taki event się odbył
  if(Yosemite.EventStateManager.anastasiaFirstSexEvent) {
    return false;
  }

  // czy był już event pierwszy pocałunek
  if(!Yosemite.EventStateManager.anastasiaFirstKissDate) {
    return false;
  }

  // czy dziś odbył się już jakikolwiek event
  if(Yosemite.EventStateManager.anastasiaDailyEventChecked) {
    return false;
  }

  // na koniec sprawdzamy statystyki
  return Yosemite.McManager.getFitness() >= 10;
}

AnastasiaEvents.isUnplannedVisit = () => {
  // czy odbył się pierwszy event z Samanthą
  if(!EventStateService.samanthaFirstEvent) {
    return false;
  }

  // czy już się odbył
  return !EventStateService.anastasiaUnplannedVisit;
}

AnastasiaEvents.isMettingVicky = () => {
  // czy odbyła się nieplanowana wizyta Anastasii
  if(!EventStateService.anastasiaUnplannedVisit) {
    return false;
  }

  // czy dziś odbył się już jakikolwiek event
  if(Yosemite.EventStateManager.anastasiaDailyEventChecked) {
    return false;
  }

  // czy odbył się wspólny trening z Vicky
  if(!Yosemite.EventStateManager.state.gym.vicky.training) {
    return false;
  }

  // czy już się odbył
  return !EventStateService.anastasiaMettingVicky;
}

AnastasiaEvents.meetingWithParents = () => {
  // czy odbyło się spotkanie razem z Vicky w parku
  if(!EventStateService.anastasiaMettingVicky) {
    return false;
  }

  // czy odbyło się spotkanie razem z Vicky w barze
  if(!EventStateService.vickyFirstMeetingAnastasiaInPub) {
    return false;
  }

  // czy dziś odbył się już jakikolwiek event
  if(Yosemite.EventStateManager.anastasiaDailyEventChecked) {
    return false;
  }

  // czy ten event już się odbył
  return !EventStateService.anastasiaMettingParents;
}

AnastasiaEvents.disappear = () => {
  // czy odbył się poprzedni event
  if(!EventStateService.anastasiaMettingParents) {
    return false;
  }

  // czy dziś odbył się już jakikolwiek event
  if(Yosemite.EventStateManager.anastasiaDailyEventChecked) {
    return false;
  }

  // czy odbył się ten event
  return !EventStateService.anastasiadisappear;
}
